import React, { useState } from 'react';
import { trackEvent } from '../utils/pixel';
import { FadeIn, Button } from './Shared';
import { ChevronDown, Lock, Download, ArrowRight } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
function FAQItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-brand-teal/10 last:border-0" data-id="element-44">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full py-6 flex items-center justify-between text-left focus:outline-none" data-id="element-45">
        <span className="text-lg font-bold text-brand-teal pr-8" data-id="element-46">
          {question}
        </span>
        <ChevronDown className={`w-5 h-5 text-brand-teal transition-transform duration-300 shrink-0 ${isOpen ? 'rotate-180' : ''}`} data-id="element-47" />
      </button>
      <AnimatePresence data-id="element-48">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3
      }} className="overflow-hidden" data-id="element-49">
            <p className="pb-6 text-brand-charcoal/80 leading-relaxed" data-id="element-50">
              {answer}
            </p>
          </motion.div>}
      </AnimatePresence>
    </div>;
}
export function Checkout() {
  const faqs = [{
    q: '¿Realmente funciona si llevo años siendo dependiente?',
    a: 'Sí, porque el método ataca la química cerebral, no solo la voluntad.'
  }, {
    q: '¿Tengo que bloquearlo de todas partes?',
    a: 'Es la recomendación técnica para que el Neuro-Reset sea efectivo y rápido.'
  }, {
    q: '¿Qué pasa si tenemos hijos en común?',
    a: 'El protocolo incluye ajustes para gestionar la logística necesaria sin romper el cordón emocional.'
  }, {
    q: '¿Es muy difícil de leer?',
    a: 'No, es un manual directo al grano, diseñado para ser ejecutado incluso si estás bajo mucho estrés emocional.'
  }];
  return <section className="py-24 bg-brand-cream" data-id="element-51">
      <div className="max-w-3xl mx-auto px-6 lg:px-8" data-id="element-52">
        {/* FAQ */}
        <FadeIn data-id="element-53">
          <h2 className="text-3xl font-heading text-center text-brand-teal mb-12" data-id="element-54">
            Preguntas Frecuentes
          </h2>
          <div className="bg-white rounded-3xl p-8 shadow-sm mb-24" data-id="element-55">
            {faqs.map((faq, i) => <FAQItem key={i} question={faq.q} answer={faq.a} data-id="element-56" />)}
          </div>
        </FadeIn>

        {/* Offer Block */}
        <FadeIn data-id="element-57">
          <div id="offer" className="bg-brand-teal rounded-3xl p-8 md:p-12 text-center relative overflow-hidden shadow-2xl" data-id="element-58">
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-brand-gold/20 via-brand-gold to-brand-gold/20" data-id="element-59"></div>

            <h2 className="text-3xl md:text-4xl font-heading text-brand-cream mb-6" data-id="element-60">
              Recupera el mando de tu vida hoy mismo.
            </h2>

            <p className="text-lg text-brand-cream/80 mb-10 leading-relaxed max-w-2xl mx-auto" data-id="element-61">
              El Protocolo de "Desconexión Segura" es tu mapa de salida del
              laberinto emocional por una inversión única que representa menos
              de lo que gastarías en una cena para intentar distraerte.
            </p>

            <div className="bg-brand-cream/10 rounded-2xl p-8 mb-10 border border-brand-gold/20 backdrop-blur-sm" data-id="element-62">
              <p className="text-brand-cream/80 uppercase tracking-widest text-sm font-bold mb-4" data-id="element-63">
                Inversión en tu nueva libertad
              </p>
              <div className="flex items-center justify-center gap-4 mb-3" data-id="element-64">
                <span className="text-2xl text-brand-cream/40 line-through font-heading" data-id="element-65">
                  $29.99
                </span>
                <span className="inline-flex items-center px-3 py-1 rounded-full bg-brand-gold text-brand-teal text-sm font-bold" data-id="element-66">
                  -78%
                </span>
              </div>
              <div className="flex items-center justify-center text-brand-gold" data-id="element-67">
                <span className="text-7xl font-heading font-bold" data-id="element-68">$6.36</span>
                <span className="text-xl ml-2 mt-4" data-id="element-69">USD</span>
              </div>
            </div>

            <Button onClick={() => {
            trackEvent('AddToCart', {
              content_name: 'Protocolo de Desconexión Segura',
              content_type: 'product',
              value: 17.99,
              currency: 'USD'
            });
            window.open('https://conocimientomarket.com/cart/43903043207265:1', '_blank');
          }} className="w-full md:w-auto text-xl px-12 py-5 group mb-6" data-id="element-70">
              Obtén Acceso Inmediato al Protocolo
              <ArrowRight className="ml-3 w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-71" />
            </Button>

            <div className="flex flex-col md:flex-row items-center justify-center gap-6 text-brand-cream/60 text-sm" data-id="element-72">
              <div className="flex items-center" data-id="element-73">
                <Download className="w-4 h-4 mr-2" data-id="element-74" />
                Recibe el PDF al instante
              </div>
              <div className="flex items-center" data-id="element-75">
                <Lock className="w-4 h-4 mr-2" data-id="element-76" />
                Pago 100% Seguro
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}